import styled from '@emotion/styled';

export const SFiltersContainer = styled.div`
  display: flex;
`;

export const STreeSelectContainer = styled.div`
  margin-left: 16px;
  width: 276px;
`;
